// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3nx4C","clinicsSelect":"TableHeading_clinicsSelect__1VI9Y"};